<template>
    <div>
        <file-pond ref="pond"
                   name="test"
                   allow-multiple="true"
                   allow-replace="false"
                   allow-remove="false"
                   allow-revert="false"
                   max-files="3"
                   :server="fileServer"
                   @processfiles="onProcessFiles" />

        <div v-if="loading" class="flex justify-center py-10">
            <d-loader />
        </div>
        <div v-else class="flex -mx-8 divide-x-4 divide-secondary-500 pt-10">
            <div class="w-full px-8 pb-10">
                <p class="text-3xl font-bold">
                    Assets
                </p>

                <!-- Search Input -->
                <input type="text"
                       v-model="searchQuery"
                       placeholder="Search Assets"
                       class="border rounded p-2 mb-4 w-full" />

                <div v-if="filteredFiles.length === 0" class="pt-3">
                    No assets match your search
                </div>
                <div v-else class="divide-y divide-secondary-400">
                    <div v-for="file in filteredFiles" :key="file.id" class="flex justify-between items-center p-5 divide-y divide-secondary-500">
                        <div class="flex items-center">
                            <img :src="file.iconUrl" alt="Icon Image" class="h-10">
                            <div class="mx-5">
                                <p>{{ file.fileName }}</p>
                                <p>{{ file.fileUrl }}</p>
                                <p class="text-sm">
                                    {{ file.createdAt | formatDate }}
                                </p>
                            </div>
                        </div>

                        <!-- Copy URL Button -->
                        <d-btn
                                @click="copyToClipboard(file.fileUrl)">
                            Copy URL
                        </d-btn>

                        <d-icon icon="trash" class="text-error cursor-pointer" @click="removeItem(file)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vueFilePond from 'vue-filepond';
    import axios from 'axios';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

    // Assuming you want to keep the upload logic in this file
    const FilePond = vueFilePond(FilePondPluginFileValidateType);

    async function uploadFile(contentListingId, file) {
        const form = new FormData();
        form.append('file', file);
        const { data } = await axios.post(`/api/content-listings/${contentListingId}/assets`, form, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    }

    export default {
        inject: ['contentListing'],
        components: {
            FilePond,
        },
        data() {
            return {
                loading: false,
                files: [], // List of all files
                searchQuery: '', // Holds the search query
                fileServer: {
                    process: async (fieldName, file, metadata, load) => {
                        // Using the external uploadFile function for consistency
                        const fileUrl = await uploadFile(this.contentListing.id, file);
                        load(fileUrl); // Call load() to signal that the process is complete
                    },
                },
            };
        },
        computed: {
            // Computed property to filter files based on the search query
            filteredFiles() {
                if (!this.searchQuery) {
                    return this.files;
                }
                return this.files.filter(file =>
                    file.fileUrl.toLowerCase().includes(this.searchQuery.toLowerCase())
                );
            },
        },
        methods: {
            // Method to fetch the list of files from the server
            async getFiles() {
                this.loading = true;
                const { data } = await axios.get(`/api/content-listings/${this.contentListing.id}/assets`);
                this.files = data;
                this.loading = false;
            },
            // Method to delete an asset
            async removeItem(item) {
                await axios.delete(`/api/assets/${item.id}`);
                await this.getFiles();
            },
            // FilePond callback to refresh files after processing
            onProcessFiles() {
                this.getFiles();
            },
            // Method to copy a URL to the clipboard
            copyToClipboard(url) {
                navigator.clipboard.writeText(url).then(() => {
                    alert('URL copied to clipboard');
                }).catch(err => {
                    console.error('Failed to copy URL: ', err);
                });
            },
        },
        mounted() {
            this.getFiles();
        },
    };
</script>
